import React, { FC, ReactElement, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "antd";

import {
  MobileOutlined,
  HomeOutlined,
  ShoppingOutlined,
  LaptopOutlined,
  HeartOutlined,
  ToolOutlined,
  GiftOutlined,
  SmileOutlined,
  BookOutlined,
} from "@ant-design/icons";

import CarouselImageSlider from "./CarouselImageSlider/CarouselImageSlider";
import SliderBrands from "./SliderBrands/SliderBrands";
import PerfumeCardsSlider from "./PerfumeCardsSlider/PerfumeCardsSlider";
import HomePageTheme from "./HomePageTheme/HomePageTheme";
import { fetchHomeData } from "../../redux-toolkit/home/home-slice";
import { RootState } from "../../store";
import "./Home.css";

const { Text } = Typography;

interface Category {
  name: string;
  icon: ReactElement;
}

const defaultCategories: Category[] = [
  { name: "Mobile Phones", icon: <MobileOutlined /> },
  { name: "Home & Kitchen", icon: <HomeOutlined /> },
  { name: "Fashion", icon: <ShoppingOutlined /> },
  { name: "Electronics & Appliances", icon: <LaptopOutlined /> },
  { name: "Beauty & Personal Care", icon: <HeartOutlined /> },
  { name: "Baby & Kids", icon: <SmileOutlined /> },
  { name: "Furniture", icon: <HomeOutlined /> },
  { name: "Industrial & Machinery", icon: <ToolOutlined /> },
  { name: "Books & Stationery", icon: <BookOutlined /> },
  { name: "Sports & Fitness", icon: <ShoppingOutlined /> },
  { name: "Apparel & Gifts", icon: <GiftOutlined /> },
  { name: "Footwear", icon: <ShoppingOutlined /> }, // No new icon as per your request
];

const Home: FC = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { data: homeData } = useSelector((state: RootState) => state.home);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchHomeData());
  }, [dispatch]);

  const handleCategoryClick = (categoryName: string) => {
    history.push(`/menu?search=${encodeURIComponent(categoryName)}`);
  };

  const categories = homeData?.categories?.length
    ? homeData.categories.map((name: string) => ({
        name,
        icon: <ShoppingOutlined />,
      }))
    : defaultCategories;

  return (
    <div className="home-wrapper">
      {/* Categories Grid */}
      <div className="home-categories-scroll">
        {categories.map((category) => (
          <div
            key={category.name}
            className="home-category-card"
            onClick={() => handleCategoryClick(category.name)}
          >
            <div className="icon">{category.icon}</div>
            <Text className="label">{category.name}</Text>
          </div>
        ))}
      </div>

      {/* Banner */}
      <div className="home-banner">
        <CarouselImageSlider items={homeData?.sliderItems || []} />
      </div>

      {/* Brands */}
      <div className="home-brands-section">
        <SliderBrands brands={homeData?.brands || []} />
      </div>

      {/* Featured Products */}
      <div className="home-products-section">
        <PerfumeCardsSlider perfumes={homeData?.perfumes || []} />
      </div>
    </div>
  );
};

export default Home;
